module.exports = __webpack_public_path__ + "static/opengraph-d23b5350240dba4ee4f230a0eb43a529.png";